var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"d-flex flex-column min-vh-100"},[_c('Menubar',{attrs:{"msg":"test"}}),_vm._m(0),_c('div',{staticClass:"wrapper flex-grow-1"}),_c('Footbar',{attrs:{"msg":"test"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"10rem"}},[_c('h6',[_vm._v("Sorry, our site is under construction.")])])
}]

export { render, staticRenderFns }